<script>
  export let company;
  export let date;
  export let id;
  export let recurring = 0;
</script>

<div class="d-flex flex-row justify-content-between task-details-content mb-2 py-1 cursor">
  <div class="w-100">
    <a
      href="/redirect/task#action={recurring == 1 ? 'scheduleTask' : 'openTask'}&openTaskId={id}"
      target="_blank"><span class="font-size-12 text-break">{company}</span></a
    >
  </div>
  <div class="d-flex flex-row align-items-center text-start time-stamp">
    <img
      alt=""
      class="mx-1 icon-14 clock-icon"
      src="/images/clock.svg"
    />
    <span class="text-muted font-size-12">{date}</span>
  </div>
</div>

<style lang="scss">
  .task-details-content {
    border-bottom: 1px solid $input-border-color;
  }
  .time-stamp {
    flex: 0 0 100px;
    max-width: 100px;
  }
</style>
